export const TVState = {
  OFF: 'OFF',
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  PLAYING: 'PLAYING',
  ERROR: 'ERROR'
};

